import * as React from 'react'
import { DownTime, DowntimePropertyName, AlarmGroup } from '../../../model/DownTime'
import ValidationMessageList from '../ValidationMessageList'
import { LockStatus } from '../../../model/DownTimeEnums'

type Props = {
  downtime: DownTime
  alarmGroups: AlarmGroup[]
  updateDowntime: (downtime: DownTime) => void
}

export class GroupCell extends React.Component<Props> {
  public render(): JSX.Element {
    const { downtime, alarmGroups, updateDowntime } = this.props
    if (downtime.lockStatus === LockStatus.notLocked) {
      return (
        <div>
          <select
            value={downtime.group}
            onChange={e => {
              const group = alarmGroups.find(g => g.name === e.target.value)
              if (!group) {
                alert(`The selected group ${group} is not valid.`)
              } else {
                updateDowntime(
                  new DownTime({
                    ...downtime,
                    subGroup: group.subGroups[0],
                    group: group.name
                  })
                )
              }
            }}
            className="form-control"
          >
            {alarmGroups &&
              alarmGroups.map(group => (
                <option value={group.name} key={group.name}>
                  {group.name}
                </option>
              ))}
          </select>
          <ValidationMessageList property={DowntimePropertyName.Group} downtime={downtime} />
        </div>
      )
    } else {
      return (
        <div>
          <p>{downtime.group}</p>
          <ValidationMessageList property={DowntimePropertyName.Group} downtime={downtime} />
        </div>
      )
    }
  }
}

export default GroupCell
